import appConfigCoverGoDev from "./appConfigCoverGoDev.js"
import appConfigAliCloudDev from "./appConfigAliCloudDev.js"
import appConfigAliCloudProd from "./appConfigAliCloudProd.js"
import { COVERGO_ASIA_PRE_PROD } from "../consts.js"

const BOC_ALICLOUD_DEV = {
	COVERGO_GRAPHQL: "https://wwwuat.bocgins.com/graphql",
	COVERGO_FILE_SYSTEM: "https://wwwuat.bocgins.com/api/v1/files",
}

const BOC_ALICLOUD_PROD = {
	COVERGO_GRAPHQL: "https://www.bocgins.com/graphql",
	COVERGO_FILE_SYSTEM: "https://www.bocgins.com/api/v1/files",
}

export const boc = {
	"boc-uat-studio.quote.hk": { appConfig: appConfigCoverGoDev, envConfig: COVERGO_ASIA_PRE_PROD },
	"192.168.22.21:32106": { appConfig: appConfigAliCloudDev, envConfig: BOC_ALICLOUD_DEV },
	"192.168.202.22:32106": {
		appConfig: appConfigAliCloudProd,
		envConfig: BOC_ALICLOUD_PROD,
	},
}
